import { withDependencies } from '@wix/thunderbolt-ioc'

export const PostNavigationFocusSymbol = Symbol('PostNavigationFocus')

export interface IPostNavigationFocus {
	focus: () => void
}

const postNavigationFocusFactory = (): IPostNavigationFocus => {
	return {
		focus: () => {
			if (process.env.browser) {
				const target = document.querySelector('main section') as HTMLElement
				target?.setAttribute('tabIndex', '-1')
				target?.setAttribute('aria-label', 'main content')
				target?.focus({ preventScroll: true })
			}
		},
	}
}

export const PostNavigationFocus = withDependencies([], postNavigationFocusFactory)
